import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import guestRoute from '@/auth/middleware/guestRoute'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  token: '',
}

const resetPasswordSearchSchema = type({
  token: searchParamString.default(DEFAULT_VALUES.token),
})

export const Route = createFileRoute('/auth/reset-password')({
  validateSearch: resetPasswordSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
  beforeLoad: ({context}) => {
    guestRoute(context.store, '/')
  },
})
